import cloneDeep from 'lodash/cloneDeep';
import { EMPTY_LEVEL } from '../game/level/EmptyLevel';
import type {
  AdBlockerState,
  BirdHouseBlockerState,
  BlockerState,
  KnotBlockerState,
  CoinBlockerState,
  PlankBlockerState,
  RocketBlockerState,
  ScoreBlockerState,
  TapeBlockerState,
  MeasureTapeBlockerState,
} from '../game/boardMVC/types';
import { BlockerType } from '../game/boardMVC/types';

export const DEFAULT_LEVEL_DATA = cloneDeep(EMPTY_LEVEL);

export const MAX_HISTORY_LENGTH = 100;

export const TRAY_STACKS = 100;

export const BOARD_DEFAULT_SIZE = { cols: 8, rows: 8 };

export const DEFAULT_BLOCKER_STATES: Record<BlockerType, BlockerState> = {
  [BlockerType.Score]: {
    type: BlockerType.Score,
    score: 100,
  } as ScoreBlockerState,
  [BlockerType.Ad]: {
    type: BlockerType.Ad,
  } as AdBlockerState,
  [BlockerType.Plank]: {
    type: BlockerType.Plank,
    hp: 3,
  } as PlankBlockerState,
  [BlockerType.Tape]: {
    type: BlockerType.Tape,
    hp: 3,
  } as TapeBlockerState,
  [BlockerType.Knot]: {
    type: BlockerType.Knot,
    hp: 4,
    connectedTo: [],
  } as KnotBlockerState,
  [BlockerType.BirdHouse]: {
    type: BlockerType.BirdHouse,
  } as BirdHouseBlockerState,
  [BlockerType.Star]: {
    type: BlockerType.Star,
  },
  [BlockerType.Rocket]: {
    type: BlockerType.Rocket,
    hp: 4,
  } as RocketBlockerState,
  [BlockerType.Coin]: {
    type: BlockerType.Coin,
    price: 300,
  } as CoinBlockerState,
  [BlockerType.MeasureTape]: {
    type: BlockerType.MeasureTape,
    connectedTo: [],
    isCase: true,
  } as MeasureTapeBlockerState,
};
